import { r as registerInstance, h, g as getElement, H as Host } from './index-bab40f02.js';
import { B as ButtonType, T as ThemePalette } from './button.interface-8b68043a.js';
var ispuiButtonCss = "ispui-button.ispui-button__host{-webkit-appearance:none}.ispui-button{-webkit-box-sizing:border-box;box-sizing:border-box;width:var(--ispui-button__width, auto);min-width:var(--ispui-button__min-width, auto);max-width:var(--ispui-button__max-width, none);padding-top:0;padding-right:var(--ispui-button__padding-right, 14px);padding-bottom:0;padding-left:var(--ispui-button__padding-left, 14px);cursor:pointer;-webkit-transition-duration:0.25s;transition-duration:0.25s;-webkit-transition-property:background-color, color, fill, stroke;transition-property:background-color, color, fill, stroke;text-align:center;vertical-align:var(--ispui-button__vertical-align, middle);white-space:nowrap;border-width:1px;border-style:solid;border-radius:3px;-webkit-box-shadow:0 1px 2px 0 rgba(64, 61, 4, 0.44);box-shadow:0 1px 2px 0 rgba(64, 61, 4, 0.44);font:var(--ispui-button__font, 14px Ubuntu, sans-serif);line-height:var(--ispui-button__line-height, 28px);stroke:var(--ispui-button__icon-stroke, #0279c0);fill:var(--ispui-button__icon-fill, transparent)}.ispui-button:hover{stroke:var(--ispui-button__icon-stroke_hover, #0991e2);fill:var(--ispui-button__icon-fill_hover, transparent);-webkit-transition-duration:0.2s;transition-duration:0.2s}.ispui-button:active{stroke:var(--ispui-button__icon-stroke_active, #035b90);fill:var(--ispui-button__icon-fill_active, transparent);-webkit-transition-duration:0.1s;transition-duration:0.1s}.ispui-button:disabled{cursor:not-allowed;color:var(--ispui-button__inactive_text_regular, #9b9b9b);border-color:transparent;background-color:var(--ispui-button__inactive_background_regular, #f4f4f4);-webkit-box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.44);box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.44);stroke:var(--ispui-button__inactive-icon-stroke, #9b9b9b);fill:var(--ispui-button__inactive-icon-fill, transparent)}.ispui-button:disabled:hover{color:var(--ispui-button__inactive_text_hover, #9b9b9b);border-color:transparent;background-color:var(--ispui-button__inactive_background_hover, #f4f4f4);stroke:var(--ispui-button__inactive-icon-stroke_hover, #9b9b9b);fill:var(--ispui-button__inactive-icon-fill_hover, transparent)}.ispui-button:disabled:active{color:var(--ispui-button__inactive_text_active, #9b9b9b);border-color:transparent;background-color:var(--ispui-button__inactive_background_active, #f4f4f4);stroke:var(--ispui-button__inactive-icon-stroke_active, #9b9b9b);fill:var(--ispui-button__inactive-icon-fill_active, transparent)}.ispui-button_theme_accent{color:var(--ispui-button__accent_text_regular, #344a5e);border-color:var(--ispui-button__accent_border_regular, transparent);background-color:var(--ispui-button__accent_background_regular, #f8e71c)}.ispui-button_theme_accent:hover{color:var(--ispui-button__accent_text_hover, #344a5e);border-color:var(--ispui-button__accent_border_hover, transparent);background-color:var(--ispui-button__accent_background_hover, #fff680)}.ispui-button_theme_accent:active{color:var(--ispui-button__accent_text_active, #344a5e);border-color:var(--ispui-button__accent_border_active, transparent);background-color:var(--ispui-button__accent_background_active, #ffd200)}.ispui-button_theme_primary{color:var(--ispui-button__primary_text_regular, #ffffff);border-color:var(--ispui-button__primary_border_regular, transparent);background-color:var(--ispui-button__primary_background_regular, #0279c0)}.ispui-button_theme_primary:hover{color:var(--ispui-button__primary_text_hover, #ffffff);border-color:var(--ispui-button__primary_border_hover, transparent);background-color:var(--ispui-button__primary_background_hover, #0891e2);-webkit-box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.44);box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.44)}.ispui-button_theme_primary:active{color:var(--ispui-button__primary_text_active, #ffffff);border-color:var(--ispui-button__primary_border_active, transparent);background-color:var(--ispui-button__primary_background_active, #025b90);-webkit-box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.44);box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.44)}.ispui-button_theme_secondary{color:var(--ispui-button__secondary_text_regular, #344a5e);border-color:var(--ispui-button__primary_border_regular, transparent);background-color:var(--ispui-button__secondary_background_regular, #c4e9ff);-webkit-box-shadow:none;box-shadow:none}.ispui-button_theme_secondary:hover{color:var(--ispui-button__secondary_text_hover, #344a5e);border-color:var(--ispui-button__primary_border_hover, transparent);background-color:var(--ispui-button__secondary_background_hover, #eaf7ff)}.ispui-button_theme_secondary:active{color:var(--ispui-button__secondary_text_active, #344a5e);border-color:var(--ispui-button__primary_border_active, transparent);background-color:var(--ispui-button__secondary_background_active, #8ed5ff)}.ispui-button_theme_third{color:var(--ispui-button__third_text_regular, #ffffff);border-color:var(--ispui-button__third_border_regular, #ffffff);background-color:var(--ispui-button__third_background_regular, rgba(255, 255, 255, 0.4));-webkit-box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.4);box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.4)}.ispui-button_theme_third:hover{color:var(--ispui-button__third_text_hover, #ffffff);border-color:var(--ispui-button__third_border_hover, #ffffff);background-color:var(--ispui-button__third_background_hover, rgba(255, 255, 255, 0.5))}.ispui-button_theme_third:active{color:var(--ispui-button__third_text_active, #ffffff);border-color:var(--ispui-button__third_border_active, #ffffff);background-color:var(--ispui-button__third_background_active, rgba(255, 255, 255, 0.2))}.ispui-button_theme_fourth{color:var(--ispui-button__fourth_text_regular, #f4f4f4);border-color:var(--ispui-button__fourth_border_regular, transparent);background-color:var(--ispui-button__fourth_background_regular, transparent);-webkit-box-shadow:none;box-shadow:none}.ispui-button_theme_fourth:hover{color:var(--ispui-button__fourth_text_hover, #f8e71c);border-color:var(--ispui-button__fourth_border_hover, transparent);background-color:var(--ispui-button__fourth_background_hover, transparent)}.ispui-button_theme_fourth:active{color:var(--ispui-button__fourth_text_active, #fffabb);border-color:var(--ispui-button__fourth_border_active, transparent);background-color:var(--ispui-button__fourth_background_active, transparent)}.ispui-button_theme_fifth{color:var(--ispui-button__fifth_text_regular, #282828);border-color:var(--ispui-button__fifth_border_regular, #282828);border-radius:4px;background-color:var(--ispui-button__fifth_background_regular, #ffffff);-webkit-box-shadow:none;box-shadow:none;line-height:33px}.ispui-button_theme_fifth:hover{color:var(--ispui-button__fifth_text_hover, #ffffff);border-color:var(--ispui-button__fifth_border_hover, #282828);background-color:var(--ispui-button__fifth_background_hover, #282828)}.ispui-button_theme_fifth:active{color:var(--ispui-button__fifth_text_active, #d8d8d8);border-color:var(--ispui-button__fifth_border_active, #282828);background-color:var(--ispui-button__fifth_background_active, #3f3d3d)}.ispui-button_theme_fifth:focus{color:var(--ispui-button__fifth_text_focus, #ffffff);border-color:var(--ispui-button__fifth_border_focus, #282828);outline:0;background-color:var(--ispui-button__fifth_background_focus, #282828)}.ispui-button_theme_sixth{color:#0279c0;border:1px solid #0279c0;border-radius:3px;background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.ispui-button_theme_sixth:hover{color:#0991e2;border-color:#0991e2;background-color:transparent}.ispui-button_theme_sixth:active{color:#035b90;border-color:#035b90;background-color:transparent}.ispui-button_theme_sixth:disabled{color:#d9d9d9;border-color:#d9d9d9;background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.ispui-button_theme_sixth:disabled:hover{color:#d9d9d9;border-color:#d9d9d9;background-color:transparent}";
var Button = /** @class */ (function () {
    function Button(hostRef) {
        registerInstance(this, hostRef);
        /** mousedown state */
        this._isMouseDown = false;
        /** property type for render */
        this.buttonType = ButtonType.button;
        /** property theme for render */
        this.buttonTheme = ThemePalette.accent;
        /** disabled button */
        this.disabled = false;
    }
    /**
     * Watch theme prop for validate it
     */
    Button.prototype.validateTheme = function (newTheme) {
        if (!newTheme) {
            return;
        }
        if (Object.keys(ThemePalette).includes(newTheme)) {
            this.buttonTheme = newTheme;
        }
        else {
            console.warn("Theme \"" + newTheme + "\" is not valid");
        }
    };
    /**
     * Watch type prop for validate it
     */
    Button.prototype.validateButtonType = function (newButtonType) {
        if (!newButtonType) {
            return;
        }
        if (Object.values(ButtonType).includes(newButtonType)) {
            this.buttonType = newButtonType;
        }
        else {
            console.warn("Type \"" + newButtonType + "\" is not valid");
        }
    };
    /**
     * Set mousedown state
     */
    Button.prototype.mouseDownHandler = function () {
        this._isMouseDown = true;
    };
    /**
     * Unset mousedown state
     */
    Button.prototype.mouseUpHandler = function () {
        this._isMouseDown = false;
    };
    /**
     * Call blur if mousedown, for not show focus state when click by button
     */
    Button.prototype.focusHandler = function () {
        if (this._isMouseDown) {
            this._button.blur();
        }
    };
    /**
     * LYFECYCLE
     *
     * Validate props on willLoad hook
     */
    Button.prototype.componentWillLoad = function () {
        this.validateTheme(this.theme);
        this.validateButtonType(this.type);
    };
    /**
     * LYFECYCLE
     *
     * Add event listener for button clicks
     */
    Button.prototype.componentDidLoad = function () {
        this._addEventListenerForButton();
        this.hostEl.classList.add('ispui-button__host');
    };
    /**
     * LYFECYCLE
     *
     * Remove event listener for button clicks
     */
    Button.prototype.componentDidUnLoad = function () {
        this._removeEventListenerForButton();
    };
    /**
     * Add event listerner for button, for unset focus
     */
    Button.prototype._addEventListenerForButton = function () {
        this._button.addEventListener('focus', this.focusHandler.bind(this));
    };
    /**
     * Remove event listener after unload component
     */
    Button.prototype._removeEventListenerForButton = function () {
        this._button.removeEventListener('focus', this.focusHandler);
    };
    Button.prototype.render = function () {
        var _this = this;
        return (h("button", { ref: function (el) { return (_this._button = el); }, class: "ispui-button ispui-button_theme_" + this.buttonTheme, type: this.buttonType, disabled: this.disabled }, h("slot", null)));
    };
    Object.defineProperty(Button.prototype, "hostEl", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button, "watchers", {
        get: function () {
            return {
                "theme": ["validateTheme"],
                "type": ["validateButtonType"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return Button;
}());
Button.style = ispuiButtonCss;
var ButtonIcon = /** @class */ (function () {
    function ButtonIcon(hostRef) {
        registerInstance(this, hostRef);
        /** default styles */
        this._styles = {
            position: 'relative',
            display: 'inline-block',
            'line-height': '0',
        };
        /** SVG icon top offset (default 5)*/
        this.top = 5;
        /** SVG icon right offset (default 20)*/
        this.right = 20;
    }
    /**
     * Convert number values to px and set icon top offset
     */
    ButtonIcon.prototype.convertTopOffset = function (top) {
        if (!top) {
            return;
        }
        if (typeof top !== 'number') {
            console.warn('Parameter "top" must be number value');
        }
        else {
            this.topOffset = top + "px";
        }
    };
    /**
     * Convert number values to px and set icon right padding
     */
    ButtonIcon.prototype.convertLeftPadding = function (left) {
        if (!left) {
            return;
        }
        if (typeof left !== 'number') {
            console.warn('Parameter "left" must be number value');
        }
        else {
            this.leftPadding = left + "px";
        }
    };
    /**
     * Convert number values to px and set icon left padding
     */
    ButtonIcon.prototype.convertRightPadding = function (right) {
        if (!right) {
            return;
        }
        if (typeof right !== 'number') {
            console.warn('Parameter "right" must be number value');
        }
        else {
            this.rightPadding = right + "px";
        }
    };
    /**
     * Get props values when component initially loads
     */
    ButtonIcon.prototype.componentWillLoad = function () {
        this.convertLeftPadding(this.left);
        this.convertRightPadding(this.right);
        this.convertTopOffset(this.top);
    };
    /**
     * render function
     */
    ButtonIcon.prototype.render = function () {
        var styles = Object.assign(Object.assign({}, this._styles), { top: this.topOffset, paddingRight: this.rightPadding, paddingLeft: this.leftPadding });
        return (h(Host, { style: styles }, h("slot", null)));
    };
    Object.defineProperty(ButtonIcon, "watchers", {
        get: function () {
            return {
                "top": ["convertTopOffset"],
                "left": ["convertLeftPadding"],
                "right": ["convertRightPadding"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return ButtonIcon;
}());
export { Button as ispui_button, ButtonIcon as ispui_button_icon };
